// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preferences_accordion__Lpd7T {
  background: var(--mui-palette-primary-200) !important;
  box-shadow: none;
  border: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/common/notification/preferences/index.module.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,aAAa;AACf","sourcesContent":[".accordion {\n  background: var(--mui-palette-primary-200) !important;\n  box-shadow: none;\n  border: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": `preferences_accordion__Lpd7T`
};
export default ___CSS_LOADER_EXPORT___;
